module.exports = __webpack_public_path__ + "img/point3.d031e240.png";